// fw LiveCard — the "on the clock" card. Left 4px signal bar, pills row,
// title, subtitle, BigClock, since label, then the action (a button).

import React from 'react';
import { BigClock } from './BigClock.js';
import './LiveCard.css';

export function LiveCard({ pills, title, subtitle, startedAt, sinceLabel, action, now, running = true, className = '', ...rest }) {
  return (
    <section className={['fw-live', className].filter(Boolean).join(' ')} data-tone="now" {...rest}>
      {pills ? <div className="fw-live__pills">{pills}</div> : null}
      {title ? <h2 className="fw-live__title">{title}</h2> : null}
      {subtitle ? <p className="fw-live__subtitle">{subtitle}</p> : null}
      <div className="fw-live__clock">
        <BigClock startedAt={startedAt} now={now} running={running} />
      </div>
      {sinceLabel ? <p className="fw-live__since">{sinceLabel}</p> : null}
      {action ? <div className="fw-live__action">{action}</div> : null}
    </section>
  );
}

export default LiveCard;
